import { render } from "./block_formulario.vue?vue&type=template&id=17fd3b53"
import script from "./block_formulario.vue?vue&type=script&lang=js"
export * from "./block_formulario.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__